import { render, staticRenderFns } from "./CustomerCollapse.vue?vue&type=template&id=6da62826&scoped=true"
import script from "./CustomerCollapse.vue?vue&type=script&lang=ts"
export * from "./CustomerCollapse.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCollapse.vue?vue&type=style&index=0&id=6da62826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da62826",
  null
  
)

export default component.exports